module.exports = __webpack_public_path__ + "media/images/faces/face12-d08d6d866d246cdbeb02fcb9502e92c8.jpg";